import { Label } from './label';

/** Values reuse TaskEvidenceKind spellings; photo stands for the beforePhoto, duringPhoto and afterPhoto kinds, as in assertSingleEvidenceType. */
export enum EvidenceExceptionType {
    Photo = 'photo',
    File = 'file',
    Form = 'form',
    Signature = 'signature',
    Comment = 'comment',
}

export const EVIDENCE_EXCEPTION_TYPE_LABELS: Record<EvidenceExceptionType, string> = {
    [EvidenceExceptionType.Photo]: 'Photos and video',
    [EvidenceExceptionType.File]: 'Files',
    [EvidenceExceptionType.Form]: 'Forms',
    [EvidenceExceptionType.Signature]: 'Signature',
    [EvidenceExceptionType.Comment]: 'Comment',
};

export function formatEvidenceExceptionTypes(types: EvidenceExceptionType[] | null | undefined): string {

    return Object.values(EvidenceExceptionType)
        .filter(type => types?.includes(type))
        .map(type => EVIDENCE_EXCEPTION_TYPE_LABELS[type])
        .join(', ');
}

export const EVIDENCE_EXCEPTION_TYPES_REQUIRED_MESSAGE = 'Select at least one evidence type.';

export interface EvidenceExceptionTag extends Label {
    data?: {
        evidenceTypes?: EvidenceExceptionType[]
    }
}
